export const HIGHER_EDUCATION_SPECIALIZATIONS = Object.freeze([
  "Applied Sciences",
  "Business & Management",
  "Computing",
  "Education",
  "Engineering",
  "Social Sciences",
  "Language and Literature",
  "Law",
  "Mathematics & Statistics",
  "Medicine",
  "Allied Health Sciences",
  "Psychology and Counselling",
]);

export const GENERAL_EDUCATION_AWARDS = Object.freeze([
  "Impactful Teaching",
  "Community Engagement",
  "Educational Innovation",
]);

export const CATEGORY_PARAM_TO_SELECTED_CAT = Object.freeze({
  "higher-education": "he",
  "emerging-educator": "he",
  "general-education": "sc",
});

export const CATEGORY_PARAM_TO_DATA_CATEGORY = Object.freeze({
  "higher-education": "Higher Education",
  "emerging-educator": "Emerging Educator",
  "general-education": "School Category",
});

const APPLICATION_TYPE_REQUIRED_AWARDS = Object.freeze([
  "Community Engagement",
  "Educational Innovation",
]);

const HIGHER_EDUCATION_APPLICATION_AMOUNT = 5000;
const GENERAL_EDUCATION_STANDARD_AMOUNT = 2000;
const GENERAL_EDUCATION_SCHOOL_AMOUNT = 5000;

export const isGeneralEducationAward = (award) =>
  GENERAL_EDUCATION_AWARDS.includes(award);

export const requiresApplicationType = (award) =>
  APPLICATION_TYPE_REQUIRED_AWARDS.includes(award);

export const requiresCensus = (award) => requiresApplicationType(award);

export const getApplicationAmount = ({
  selectedCat,
  award,
  applicationType,
}) => {
  if (selectedCat !== "sc") {
    return HIGHER_EDUCATION_APPLICATION_AMOUNT;
  }

  if (!requiresApplicationType(award)) {
    return GENERAL_EDUCATION_STANDARD_AMOUNT;
  }

  return applicationType === "school"
    ? GENERAL_EDUCATION_SCHOOL_AMOUNT
    : GENERAL_EDUCATION_STANDARD_AMOUNT;
};
